import { vehiclesSlice } from "./vehiclesSlice";
import * as actions from "./vehiclesActions";
import * as selectors from "./vehiclesSelectors";

export { actions };
export { selectors };

export default vehiclesSlice.reducer;
